import { useEffect, useState } from 'react';
import { useApiContext } from '@/contexts/apiContext';
import ProgressIndicator from '../progressIndicator';
import CsvViewer from './csvViewer';

type Props = {
  dataSourceDefId: string;
  dataSourceInstanceId: string;
  dataSourceItemId: string;
  filename: string;
  maxHeight: number;
  separator?: string;
  showLabel?: boolean;
  eventId?: string;
  dataSourceInstance?: any;
  parentItemName?: string;
  pipelineInstanceId?: string;
};

const CsvDataSourceItemViewer = ({
  dataSourceDefId,
  dataSourceInstanceId,
  dataSourceItemId,
  filename,
  maxHeight,
  separator = ',',
  showLabel,
  eventId,
  dataSourceInstance,
  parentItemName,
  pipelineInstanceId,
}: Props) => {
  const apiContext = useApiContext();

  const [csvContent, setCsvContent] = useState<string>('');

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>();

  useEffect(() => {
    const downloadCsv = async () => {
      setError(null);
      try {
        setLoading(true);

        const meta = dataSourceInstance?.dataSourceDef?.metadata || {};
        const getFromSourceDirectly =
          meta.hasParentChildItems === true && meta.publishParentItemEvents === false && !parentItemName;

        if (getFromSourceDirectly) {
          const data = await apiContext.getDataSourceItemContentDirectFromSource(
            dataSourceDefId,
            dataSourceInstanceId,
            filename || dataSourceItemId,
            false,
          );
          const decoder = new TextDecoder('utf-8');
          setCsvContent(decoder.decode(data));
          return;
        }

        const { content, contentType } = await apiContext.getDataSourceInstanceItem(
          dataSourceDefId,
          dataSourceInstanceId,
          dataSourceItemId,
          false,
          eventId,
          pipelineInstanceId,
        );
        const decoder = new TextDecoder('utf-8');
        const decoded = decoder.decode(content);
        try {
          const textContent = JSON.parse(decoded);
          if (textContent.type && textContent.content) {
            if (textContent.type === 'Base64Encoded') {
              setCsvContent(atob(textContent.content));
            } else {
              setCsvContent(textContent.content);
            }
          } else {
            throw new Error('Not document JSON');
          }
        } catch (e) {
          setCsvContent(decoded);
        }
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    if (dataSourceDefId && dataSourceInstanceId && dataSourceItemId) {
      downloadCsv();
    }
  }, [dataSourceDefId, dataSourceInstanceId, dataSourceItemId, eventId]);

  if (loading) {
    return <ProgressIndicator />;
  }
  return (
    <CsvViewer
      csvContent={csvContent}
      showLabel={showLabel}
      label={filename}
      error={error}
      maxHeight={maxHeight}
      separator={separator}
    />
  );
};

export default CsvDataSourceItemViewer;
